module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/climasense/fusarium_agave/curativa/vigold.png
// module id = 1033
// module chunks = 3